import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, computed, signal } from '@angular/core';

export type TrackPx = `${number}px`;
export type TrackPct = `${number}%`;

@Component({
  selector: 'progress-bar',
  standalone: true,
  imports: [NgStyle],
  template: `<span class="track"></span><span class="scale" [ngStyle]="{ width: trackSize() }"></span>`,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'progress-bar'
  }
})
export class ProgressBarComponent {
  @Input()
  initialValue: number = 0;

  @Input()
  mode: 'relative' | 'accurate' = 'relative';

  @Input()
  set value(val: number) {
    this._value.set(val);
  }

  trackSize = computed(() => {
    let val = this._value() + this.initialValue;
    val = Math.max(val, 0);
    val = Math.min(val, 100);

    // console.log(`progress bar's value: ${this.trackSize}`);

    if (this.mode === 'relative') {
      return `${val}%`;
    }

    return `${val}px`;
  });

  private _value = signal(this.initialValue);

  private recalcProgress(val: number) {}
}
